let ctx = null;
let enabled = typeof localStorage !== "undefined" && localStorage.getItem("wiki-sound") !== "off";
const listeners = new Set();

const getCtx = () => {
    if (!ctx) {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return null;
        ctx = new AC();
    }
    if (ctx.state === "suspended") ctx.resume();
    return ctx;
};

export const isSoundEnabled = () => enabled;

export const setSoundEnabled = (v) => {
    enabled = v;
    localStorage.setItem("wiki-sound", v ? "on" : "off");
    listeners.forEach((fn) => fn(v));
};

export const onSoundChange = (fn) => {
    listeners.add(fn);
    return () => listeners.delete(fn);
};

export const playKeyClick = () => {
    if (!enabled) return;
    try {
        const c = getCtx();
        if (!c) return;
        const t = c.currentTime;
        const dur = 0.035;
        const buffer = c.createBuffer(1, Math.floor(c.sampleRate * dur), c.sampleRate);
        const data = buffer.getChannelData(0);
        for (let i = 0; i < data.length; i++) {
            data[i] = (Math.random() * 2 - 1) * (1 - i / data.length);
        }
        const noise = c.createBufferSource();
        noise.buffer = buffer;
        const hp = c.createBiquadFilter();
        hp.type = "highpass";
        hp.frequency.value = 2000 + Math.random() * 800;
        const ng = c.createGain();
        ng.gain.setValueAtTime(0.14, t);
        ng.gain.exponentialRampToValueAtTime(0.001, t + dur);
        noise.connect(hp).connect(ng).connect(c.destination);
        noise.start(t);

        const osc = c.createOscillator();
        osc.type = "square";
        osc.frequency.setValueAtTime(180 + Math.random() * 90, t);
        const og = c.createGain();
        og.gain.setValueAtTime(0.05, t);
        og.gain.exponentialRampToValueAtTime(0.001, t + 0.045);
        osc.connect(og).connect(c.destination);
        osc.start(t);
        osc.stop(t + 0.05);
    } catch {
        /* audio unavailable */
    }
};

export const playBeep = (freq = 880, dur = 0.07, vol = 0.07, type = "sine") => {
    if (!enabled) return;
    try {
        const c = getCtx();
        if (!c) return;
        const t = c.currentTime;
        const osc = c.createOscillator();
        osc.type = type;
        osc.frequency.setValueAtTime(freq, t);
        const g = c.createGain();
        g.gain.setValueAtTime(vol, t);
        g.gain.exponentialRampToValueAtTime(0.001, t + dur);
        osc.connect(g).connect(c.destination);
        osc.start(t);
        osc.stop(t + dur + 0.02);
    } catch {
        /* audio unavailable */
    }
};

export const playBoot = () => {
    playBeep(440, 0.09, 0.06, "square");
    setTimeout(() => playBeep(880, 0.12, 0.06, "square"), 110);
};

export const playDispatch = () => {
    playBeep(660, 0.07, 0.07);
    setTimeout(() => playBeep(990, 0.1, 0.07), 90);
};
